module.exports = __webpack_public_path__ + "img/star_select.53301dc6.png";